(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const track=root.querySelector('[data-track]');
    if(!track) return;
    const cards=[...root.querySelectorAll('[data-review]')];
    const filters=[...root.querySelectorAll('[data-rating]')];
    const all=root.querySelector('[data-show-all]');
    const status=root.querySelector('[data-status]');
    const arrows=[...root.querySelectorAll('[data-direction]')];
    let rating=0, expanded=false;
    function boundaries(){
      arrows.forEach(b=>{b.disabled=Number(b.dataset.direction)<0?track.scrollLeft<=2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2;});
    }
    function update(){
      const matching=cards.filter(c=>rating===0||Number(c.dataset.score)===rating);
      const limit=expanded?matching.length:Number(root.dataset.initial);
      cards.forEach(c=>{c.hidden=true;});
      matching.slice(0,limit).forEach(c=>{c.hidden=false;});
      filters.forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.rating)===rating)));
      status.textContent=matching.length?Math.min(limit,matching.length)+' avis affiché(s) sur '+matching.length+' disponible(s)'+(rating?' · '+rating+' étoile(s)':''):'Aucun avis disponible pour cette note.';
      all.hidden=expanded||matching.length<=limit;
      track.scrollLeft=0;
      requestAnimationFrame(boundaries);
    }
    filters.forEach(b=>b.addEventListener('click',()=>{rating=Number(b.dataset.rating);expanded=false;update();}));
    all.addEventListener('click',()=>{expanded=true;update();track.focus({preventScroll:true});});
    arrows.forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.direction)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));
    track.addEventListener('scroll',boundaries,{passive:true});
    new ResizeObserver(boundaries).observe(track);
    update();
  }
  function start(scope){scope.querySelectorAll('[data-premium-reviews]').forEach(init);}
  start(document);
  document.addEventListener('shopify:section:load',e=>start(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
